<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="loco-menu" [style.visibility]='contentPanelVisible'>
    <div id="locomotiveBriefLeftMenu" class="panel-left {{(showHeader) ? '' : 'loco-menu-no-border'}}" [style.top]='panelLeftPosY' [style.left]='panelLeftPosX' [style.width]='leftWidth' [style.height]='leftHeight'>
        <a href="javascript:void(0)" *ngIf='showHeader' class="menu-item-link" (click)='showLocomotiveTabData("Data", "Locomotive");'>
            Data
        </a>
        <a *ngIf='!isLocoStatusScreen && showHeader' href="javascript:void(0)" class="menu-item-link" (click)='showLocomotiveTabData("Data", "Locomotive-Status");'>
            Status
        </a>
        <a href="javascript:void(0)" *ngIf='showHeader' class="menu-item-link" (click)='showLocomotiveTabData("History", "Locomotive");'>
            <!--(click)='showLocomotiveTabData("History", "Locomotive");'-->
            History
        </a>
        <a href="javascript:void(0)" *ngIf='showHeader' class="menu-item-link" (click)='showLocomotiveTabData("Notes", "Locomotive");'>
            <!--(click)='showLocomotiveTabData("Notes", "Locomotive");'-->
            Notes
        </a>
        <a href="javascript:void(0)" *ngIf="showHeader && thpVisibility && !thpDisable && user && user.isUserManagerOrDirector && !isLinkDisable && !isLocoStatusScreen && !isYardLocalScreen && loco?.thpTerminal" class="menu-item-link" (click)='showUpdateTHPPopup();'>
            Update Terminal Handling Plan
        </a>
        <a href="javascript:void(0)" *ngIf="showHeader && thpVisibility && thpDisable && user && user.isUserManagerOrDirector && !isLinkDisable && !isLocoStatusScreen && !isYardLocalScreen && loco?.thpTerminal" class="menu-item-link disabled">
            Update Terminal Handling Plan
        </a>
        <a href="javascript:void(0)" *ngIf="showHeader && thpVisibility && ((user && !user.isUserManagerOrDirector) || isLinkDisable ||!loco?.thpTerminal) && !isLocoStatusScreen && !isYardLocalScreen" class="menu-item-link disabled">
            Update Terminal Handling Plan
        </a>

        <a href="javascript:void(0)" *ngIf="showHeader && !isUpdateTHP && !isLocoStatusScreen && !isYardLocalScreen && !isUpdateIntendedUsage()" class="menu-item-link disabled">
            Update Intended Usage
        </a>
        <a href="javascript:void(0)" *ngIf="showHeader && !isUpdateTHP && !isLocoStatusScreen && !isYardLocalScreen && isUpdateIntendedUsage()" class="menu-item-link" (click)='updateIntendedUsage();'>
            Update Intended Usage
        </a>

        <a href="javascript:void(0)" *ngIf="showHeader && isLocoStatusScreen && !isYardLocalScreen && user && user.isUserManagerOrDirector && !isLinkDisable" class="menu-item-link" (click)='locateLocomotive();'>
           Locate
        </a>
        <a href="javascript:void(0)" *ngIf="showHeader && isLocoStatusScreen && !isYardLocalScreen && ((user && !user.isUserManagerOrDirector) || isLinkDisable)" class="menu-item-link disabled">
           Locate
        </a>
        <a href="javascript:void(0)" *ngIf="showHeader && !isUpdateTHP && !isYardLocalScreen && user && user.isUserManagerOrDirector && !isLinkDisable && cancelPlanEnable" class="menu-item-link" (click)='cancelLocomotivePlan();'>
            Cancel Locomotive Plan
        </a>
        <a href="javascript:void(0)" *ngIf="showHeader && !isUpdateTHP && !isYardLocalScreen && ((user && !user.isUserManagerOrDirector) || isLinkDisable || !cancelPlanEnable)" class="menu-item-link disabled">
            Cancel Locomotive Plan
        </a>

        <!-- START ALLOCATE FOR TERMINAL RIBBON-->
        <a href="javascript:void(0)" *ngIf="showHeader && !isYardLocalScreen && user && user.isUserManagerOrDirector && locoStatusOpr?.header === 'NET ALLOCATION'" class="menu-item-link" (click)='allocateTerminalLocomotive();'>
            Allocate
        </a>
        <a href="javascript:void(0)" *ngIf="showHeader && !isYardLocalScreen && user  && locoStatusOpr?.header === 'NET ALLOCATION' && !user.isUserManagerOrDirector" class="menu-item-link disabled">
            Allocate
        </a>
        <!-- END ALLOCATE -->

        <!-- START DE-ALLOCATE -->
        <a href="javascript:void(0)" *ngIf="showHeader && !isYardLocalScreen && user && user.isUserManagerOrDirector && locoStatusOpr?.header === 'NET ALLOCATION'" class="menu-item-link" (click)='deAllocateTerminalLocomotive();'>
            Deallocate
        </a>
        <a href="javascript:void(0)" *ngIf="showHeader && !isYardLocalScreen && user && locoStatusOpr?.header === 'NET ALLOCATION' && !user.isUserManagerOrDirector" class="menu-item-link disabled">
            Deallocate
        </a>
        <!-- END DE-ALLOCATE -->

        <!-- START ALLOCATE -->
        <a href="javascript:void(0)" *ngIf="showHeader && isYardLocalScreen && user && user.isUserManagerOrDirector && isAllocateBtnEnabled" class="menu-item-link" (click)='allocateLocomotive();'>
            Allocate
        </a>
        <a href="javascript:void(0)" *ngIf="showHeader && isYardLocalScreen && ((user && !user.isUserManagerOrDirector) || !isAllocateBtnEnabled)" class="menu-item-link disabled">
            Allocate
        </a>
        <!-- END ALLOCATE -->

        <!-- START DE-ALLOCATE -->
        <a href="javascript:void(0)" *ngIf="showHeader && isYardLocalScreen && user && user.isUserManagerOrDirector && isDeAllocateBtnEnabled" class="menu-item-link" (click)='deAllocateLocomotive();'>
            Deallocate
        </a>
        <a href="javascript:void(0)" *ngIf="showHeader && isYardLocalScreen && ((user && !user.isUserManagerOrDirector) || !isDeAllocateBtnEnabled)" class="menu-item-link disabled">
            Deallocate
        </a>
        <!-- END DE-ALLOCATE -->

    </div>

    <div class="panel-right" id="contextPanelID" [style.top]='panelRightPosY' [style.left]='panelRightPosX'>
        <div class="loco-textPanel">
            <span class="loco-id" *ngIf="loco">{{formatLocomotiveId(loco.locomotiveIdentifier)}}</span>
            <span class="loco-class">{{loco && loco.clazz ? loco.clazz : '-'}}   </span>
        </div>
        <div class="loco-infoPanel">
            <ul>
                <li>
                    <span class="loco-label">
						{{locoLabel?.horsePower}} / {{locoLabel?.te}}
					</span>
                    <span class="loco-value">
						{{(loco && loco.horsePower) ? loco.horsePower : '-'}} / {{loco && loco.tractiveEffort ? loco.tractiveEffort : '-'}}
					</span>
                </li>
                <li>
                    <span class="loco-label">
                        {{locoLabel?.milesToEmpty}} / {{locoLabel?.capacity}}
					</span>
                    <span class="loco-value">
                        {{loco && loco.miles ? loco.miles : '-'}} / {{loco && loco.capacity ? loco.capacity : '-'}}
					</span>
                </li>
                <li>
                    <span class="loco-label" *ngIf="loco.assignedPlannedFlag !== 'A'">
                        {{locoLabel?.assignCurrent}} {{locoLabel?.assignment}}
					</span>
                    <span class="loco-label" *ngIf="loco.assignedPlannedFlag === 'A'">
                        {{locoLabel?.assignPlanned}} {{locoLabel?.assignment}}
					</span>
                    <span class="loco-value">
                        {{getPlannedAssignmentValue()}}
					</span>
                </li>
                <li>
                    <span class="loco-label">
                        {{locoLabel?.qDate}} / {{locoLabel?.type}}
					</span>
                    <span class="loco-value">
                        {{loco && loco.qDueDate ? formatDateOnly(loco.qDueDate) : '-'}} / {{loco && loco.maintenanceType ? loco.maintenanceType : '-'}}
					</span>
                </li>
                <li>
                    <span class="loco-label">
                        {{locoLabel?.deadDate}}
					</span>
                    <span class="loco-value">
                        {{loco && loco.deadDate ? formatDateOnly(loco.deadDate) : '-'}}
					</span>
                </li>
                <li>
                    <span class="loco-label">
                        {{locoLabel?.terminalHandlingPlan}}
					</span>
                    <span class="loco-value">
                        {{loco && loco.thpTerminal ? loco.thpTerminal : '-'}}  {{getThpTypeInformation(loco.thpType, loco.thpText)}}
                    </span>
                </li>
                <li *ngIf="loco?.intendedUsageCode">
                    <span class="loco-label">
                        Intended Usage
					</span>
                    <span class="loco-value no-padding">
						<ul class="context-menu-features">
							<li *ngIf="loco?.intendedUsageCode"><span class="{{loco?.intendedUsageCode === 'NP' ? 'color-red':''}}">{{appUtilService.getIntendedUsageDesc(loco?.intendedUsageCode)}}</span></li>
                <li *ngIf="getIntendedUsageReasonValue(loco?.intendedUsageReason)">{{getIntendedUsageReasonValue(loco?.intendedUsageReason)}}</li>
                <li *ngIf="loco?.intendedUsageNote">{{loco?.intendedUsageNote}}</li>
            </ul>
            </span>
            </li>
            <li>
                <span class="loco-label">
                         {{locoLabel?.responsibleRoad}} 
					</span>
                <span class="loco-value">
                        {{loco && loco.responsibleRoad ? loco.responsibleRoad : '-'}}
					</span>
            </li>
            <li>
                <span class="loco-label">
                        {{locoLabel?.direction}}	
					</span>
                <span class="loco-value">
                        {{(loco && loco.directionFacing && loco.directionFacing === 'F') ? 'Forward' : (loco && loco.directionFacing && loco.directionFacing === 'B') ? 'Backward' : 'Unknown'}}
					</span>
            </li>
            <li>
                <span class="loco-label">
                        {{locoLabel?.tagPermLoco}}
					</span>
                <span class="loco-value">
                        {{loco && loco.permanentTag ? loco.permanentTag : '-'}} / {{loco && loco.locoTag ? loco.locoTag : '-'}}
					</span>
            </li>
            <li>
                <span class="loco-label">
                        {{locoLabel?.allocationInfo}}
					</span>
                <span class="loco-value" *ngIf='loco && returnDash([loco.locoAllocDiv,loco.locoAllocStation, loco.locoAllocType, loco.locoAllocPermFlag])'>
						-
					</span>
                <span class="loco-value" *ngIf='loco && !returnDash([loco.locoAllocDiv,loco.locoAllocStation, loco.locoAllocType, loco.locoAllocPermFlag])'>
						{{loco && loco.locoAllocDiv}} {{loco.locoAllocStation}} {{loco.locoAllocType}} {{loco.locoAllocPermFlag}}
					</span>
            </li>
            <li>
                <span class="loco-label">
                        {{locoLabel?.ynlLocation}}
					</span>
                <span class="loco-value">
                        {{loco && loco.bestAvailableLocDetail ? loco.bestAvailableLocDetail : '-'}}
					</span>
            </li>
            <li>
                <span class="loco-label">
                        {{locoLabel?.terminalArrival}}
					</span>
                <span class="loco-value">
                        {{loco && loco.terminalArrival ? loco.terminalArrival : '-'}}
					</span>
            </li>
            <li>
                <span class="loco-label">
                        {{locoLabel?.terminalDuration}}
					</span>
                <span class="loco-value">
                        {{loco && loco.terminalDuration ? loco.terminalDuration : '-'}}
					</span>
            </li>
            <li>
                <span class="loco-label">
                        {{locoLabel?.assignPrevious}} {{locoLabel?.assignment}}
					</span>
                <span class="loco-value">
                        {{loco && loco.previousAssignment ? loco.previousAssignment : '-'}}
					</span>
            </li>
            <li>
                <span class="loco-label">
                        {{locoLabel?.lastReported}}	
					</span>
                <span class="loco-value" *ngIf='loco && returnDash([loco.lastReportingDateTime,loco.lastReportingMilepost])'>
                        -
					</span>
                <span class="loco-value" *ngIf='loco && !returnDash([loco.lastReportingDateTime,loco.lastReportingMilepost])'>
                        {{loco.lastReportingSource}}{{loco.lastReportingSource ? ' : ' : ''}} {{loco.lastReportingDateTime}} {{loco.lastReportingDateTime ? '@' : ''}} {{loco.lastReportingMilepost}}
					</span>
            </li>
            <li>
                <span class="loco-label">
                        {{locoLabel?.lastReportedLocation}}
					</span>
                <span class="loco-value">
                        {{(loco && loco.lastReportingCityState && loco.lastReportingCityState.trim() !== ',') ? loco.lastReportingCityState : '-'}}
					</span>
            </li>
            <li>
                <span class="loco-label">
                        {{locoLabel?.tripPlan}}
					</span>
                <span class="loco-value" *ngIf='loco?.tripPlans?.length > 0'>
                        <ul>
                            <li *ngFor='let plan of loco?.tripPlans'>
                                {{plan ? plan : '-'}}
                            </li>
                        </ul>

					</span>
                <span class="loco-value" *ngIf='!(loco?.tripPlans) || loco?.tripPlans?.length < 1'>
                        -
                    </span>
            </li>
            <li>
                <span class="loco-label">
                        {{locoLabel?.backupTripPlan}}
					</span>
                <span class="loco-value">
                        {{loco && loco.backupTripPlan ? loco.backupTripPlan : '-'}}
					</span>
            </li>
            <li>
                <span class="loco-label">
                        {{locoLabel?.problems}}
					</span>
                <span class="loco-value">
                        {{loco && loco.problemCodes ? loco.problemCodes : '-'}}
					</span>
            </li>
            <li>
                <span class="loco-label">
                        {{locoLabel?.remarks}}
					</span>
                <span class="loco-value">
                        {{loco && loco.remarks ? loco.remarks : '-'}}
					</span>
            </li>
            <li>
                <span class="loco-label">
                        {{locoLabel?.notes}}
					</span>
                <span class="loco-value">
                        {{loco && loco.noteText ? loco.noteText : '-'}}
					</span>
            </li>
            <li>
                <span class="loco-label">
                        {{locoLabel?.features}}
					</span>
                <span class="loco-value no-padding" *ngIf='(loco && loco.listOfFeature && loco.listOfFeature.length > 0)'>
						<ul class="context-menu-features">
							<li *ngFor='let feature of loco && loco.listOfFeature' 
								title="{{feature.featureDescription}}">
								{{feature.featureDescription ? feature.featureDescription : '-'}}
							</li>
						</ul>
					</span>
                <span class="loco-value" *ngIf='!(loco && loco.listOfFeature && loco.listOfFeature.length > 0)'>
                        -
                    </span>
            </li>
            </ul>
        </div>
    </div>
</div>